import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import BeforeAfterGenerationModal from '~/javascript/components/admin/page_editor/BeforeAfterGenerationModal.vue'

/**
 * Stimulus controller for before/after image generation - mounts Vue modal component
 *
 * Usage:
 *   <div data-controller="admin--before-after-image"
 *        data-admin--before-after-image-website-id-value="<%= website.id %>"
 *        data-admin--before-after-image-page-id-value="<%= page.id %>">
 *   </div>
 *
 * The modal listens for 'open-before-after-modal' window events dispatched by
 * the setupBeforeAfterOverlays function in _preview_edit_toolbar.html.erb
 */
export default class extends Controller {
  static values = {
    websiteId: String,
    pageId: String
  }

  connect() {
    this.vueApp = null
    this.vueInstance = null
    this.mountPoint = null

    // Mount Vue app immediately so it can listen for events
    this.mountVue()
  }

  disconnect() {
    this.unmountVue()
  }

  mountVue() {
    // Create mount point
    this.mountPoint = document.createElement('div')
    this.mountPoint.id = 'before-after-image-modal-mount'
    document.body.appendChild(this.mountPoint)

    // Create Vue app
    this.vueApp = createApp(BeforeAfterGenerationModal, {
      websiteId: this.websiteIdValue,
      pageId: this.pageIdValue,
      onClose: () => {
        // Optional: cleanup or refresh after modal closes
      }
    })

    // Mount and store instance reference
    this.vueInstance = this.vueApp.mount(this.mountPoint)
  }

  unmountVue() {
    if (this.vueApp) {
      this.vueApp.unmount()
      this.vueApp = null
      this.vueInstance = null
    }
    if (this.mountPoint) {
      this.mountPoint.remove()
      this.mountPoint = null
    }
  }
}
